import Swiper from './Swiper';
import './style.styl';
export { Swiper };
export default Swiper;
